<template>
    <article class="pointer" @click="toDetailsPage">
        <div class="each-product">
            <div class="product-image">
                <img
                        :src="product.images[0]['image']"
                        :alt="product.name"
                        class="image img-fluid"
                />
            </div>
            <section class="product-details">
                <h3 class="product-name">{{product.name}}</h3>

                <section class="product-meta">
                    <div>
                        <p class="price">{{product.display_price}}</p>
                        <div class="product-start-details">
                            <span class="el-icon-star-off"></span>
                            <span class="el-icon-star-off"></span>
                            <span class="el-icon-star-off"></span>
                            <span class="el-icon-star-off"></span>
                            <span class="el-icon-star-off"></span>
                        </div>
                    </div>
                    <add-to-cart-component :product="product" :is-icon-only="true"/>
                </section>
            </section>
            <section class="discount-details" v-show="product.discount">
                <h3 class="dis-percentage">{{ product.discount }} %</h3>
            </section>
        </div>
    </article>
</template>

<script>
    import AddToCartComponent from "../cart/AddToCartComponent";

    export default {
        name: "ProductItemComponent",
        components: {AddToCartComponent},
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        methods: {
            toDetailsPage() {
                this.$router.push({
                    name: 'product-details',
                    params: {slug: this.product.slug}
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .each-product {
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.22);
        position: relative;

        .product-image {
            text-align: center;
            width: 100%;

            img {
                // height: 300px;
                /*max-width: 150px;*/
            }
        }

        .product-details {
            padding: 15px;

            .price {
                color: #11233f;
                font-weight: 600;
                font-size: 1em;
                margin-bottom: 0px;
            }

            .product-name {
                margin-top: 5px;
                min-height: 66px;
            }
            .product-meta {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

        }

        .discount-details {
            position: absolute;
            top: 10px;
            left: 25px;
            .dis-percentage {
                background: #ffba69;
                color: #fff;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .product-start-details {
            span:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
